<template>
    <div>
        <!-- 顶部导航 -->
        <!-- <NavTop :class="guding ? 'daohangguding' : ''"></NavTop> -->
        <NavTop></NavTop>
        <!-- 顶部广告 -->
        <div class="banner_top">
            <div class="banner_top_m">
                <img src="@/assets/images/banner1.png">
            </div>
        </div>
        <!-- 内容 -->
        <div class="main column">
            <!-- 搜索 -->
            <!-- <div :class="guding ? 'main_search_guding main_search column' : 'main_search column'"> -->
            <div class="main_search column">
                <div class="main_search_m row">
                    <div class="main_search_m_m row">
                        <div class="main_search_m_m_leixing">
                            <div class="zhiweileixingclass" @click="zhiweileixing()">职位类型 <i
                                    class="el-icon-caret-bottom"></i></div>
                            <div id="zhiweileixingxiangqing" class="main_search_m_m_leixing_m" v-if="zhiweileixingState">
                                <div class="main_search_m_m_leixing_m_m column">
                                    <div class="main_search_m_m_leixing_m_li" v-for="(item, index) in zhiweileixingList"
                                        :key="index">
                                        <div class="main_search_m_m_leixing_m_li_text row">
                                            <span>{{ item.functionName }}</span>
                                            <i class="el-icon-caret-right"></i>
                                        </div>
                                        <div class="main_search_m_m_leixing_m_li_nr">
                                            <div class="main_search_m_m_leixing_m_li_nr_m column"
                                                v-if="item.children.length != 0">
                                                <div class="main_search_m_m_leixing_m_li_nr_m_m row"
                                                    v-for="(items, indexs) in item.children" :key="indexs">
                                                    <div class="main_search_m_m_leixing_m_li_nr_m_m_l">
                                                        {{ items.functionName }}
                                                    </div>
                                                    <div class="main_search_m_m_leixing_m_li_nr_m_m_r row"
                                                        v-if="items.children.length != 0">
                                                        <div class="main_search_m_m_leixing_m_li_nr_m_m_rm"
                                                            v-for="(itemss, indexss) in items.children" :key="indexss"
                                                            @click="clickzhiweileixing(itemss)">
                                                            {{ itemss.functionName }}
                                                        </div>
                                                    </div>
                                                    <div class="main_search_m_m_leixing_m_li_nr_m_m_rm" v-else
                                                        @click="clickzhiweileixing(items)">
                                                        {{ items.functionName }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="main_search_m_m_leixing_m_li_nr_m column" v-else>
                                                <div class="main_search_m_m_leixing_m_li_nr_m_m row">
                                                    <div class="main_search_m_m_leixing_m_li_nr_m_m_l">
                                                        {{ item.functionName }}
                                                    </div>
                                                    <div class="main_search_m_m_leixing_m_li_nr_m_m_rm"
                                                        @click="clickzhiweileixing(item)">
                                                        {{ item.functionName }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <input class="main_search_m_m_input" type="text" v-model="searchText" placeholder="搜索职位公司">
                    </div>
                    <button class="main_search_m_sousuo" @click="clickSearch()">搜索</button>
                </div>
                <!-- <div :class="guding ? 'main_search_f_guding' : 'main_search_f row'"> -->
                <div class="main_search_f row">
                    <div class="main_search_f_title">热门岗位：</div>
                    <div class="main_search_f_text">
                        <a v-for="(item, index) in hotList" :key="index" @click="clickHot(item)">{{ item.name }}</a>
                    </div>
                </div>
            </div>
            <!-- 搜索 end -->
            <!-- 主体 -->
            <div class="zhuti column">
                <!-- 主体顶部 -->
                <div class="zhuti_top row">
                    <div class="zhuti_top_l column">
                        <div class="zhuti_top_l_top column">
                            <!-- zhiweileixingList -->
                            <div class="zhuti_top_l_top_m" v-for="(item, index) in hangyeList" :key="index"
                                v-if="hangyegeshul < (index + 1) && index < hangyegeshur">
                                <div class="zhuti_top_l_top_m_l row">
                                    <div class="zhuti_top_l_top_m_l_m">
                                        <span>{{ item.functionName }}</span>
                                        <a v-if="item.children[0]" @click="clickzhiweileixing(item.children[0])">{{
                                            item.children[0].functionName }}</a>
                                        <a v-if="item.children[1]" @click="clickzhiweileixing(item.children[1])">{{
                                            item.children[1].functionName }}</a>
                                        <a v-if="item.children[2]" @click="clickzhiweileixing(item.children[2])">{{
                                            item.children[2].functionName }}</a>
                                        <a v-if="item.children[3]" @click="clickzhiweileixing(item.children[3])">{{
                                            item.children[3].functionName }}</a>
                                        <a v-if="item.children[4]" @click="clickzhiweileixing(item.children[4])">{{
                                            item.children[4].functionName }}</a>
                                        <!-- <a>前端开发工程师</a> -->
                                        <!-- <a>鸿蒙开发工程师</a> -->
                                        <!-- <a>Cocos</a> -->
                                    </div>
                                    <i class="el-icon-caret-right"></i>
                                </div>
                                <div class="zhuti_top_l_top_m_r">
                                    <div class="zhuti_top_l_top_m_r_m row">
                                        <div class="zhuti_top_l_top_m_r_mm" v-if="item.children.length != 0">
                                            <div class="zhuti_top_l_top_m_r_mmm row"
                                                v-for="(items, indexs) in item.children" :key="indexs">
                                                <div class="zhuti_top_l_top_m_r_mmm_l">
                                                    {{ items.functionName }}
                                                </div>
                                                <div class="zhuti_top_l_top_m_r_mmm_rm row"
                                                    v-if="items.children.length != 0">
                                                    <div class="zhuti_top_l_top_m_r_mmm_r row"
                                                        v-for="(itemss, indexss) in items.children" :key="indexss"
                                                        @click="clickzhiweileixing(itemss)">
                                                        <div class="zhuti_top_l_top_m_r_mmm_rmm">
                                                            {{ itemss.functionName }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="zhuti_top_l_top_m_r_mmm_rm row" v-else
                                                    @click="clickzhiweileixing(items)">
                                                    <div class="zhuti_top_l_top_m_r_mmm_r row">
                                                        <div class="zhuti_top_l_top_m_r_mmm_rmm">
                                                            {{ items.functionName }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="zhuti_top_l_top_m_r_mm" v-else>
                                            <div class="zhuti_top_l_top_m_r_mm">
                                                <div class="zhuti_top_l_top_m_r_mmm row">
                                                    <div class="zhuti_top_l_top_m_r_mmm_l">
                                                        {{ item.functionName }}
                                                    </div>
                                                    <div class="zhuti_top_l_top_m_r_mmm_r row">
                                                        <div class="zhuti_top_l_top_m_r_mmm_rmm"
                                                            @click="clickzhiweileixing(item)">
                                                            {{ item.functionName }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="zhuti_top_l_bottom row">
                            <div class="zhuti_top_l_bottom_l">{{ hangyeNum }}/{{ hangyeLength }}</div>
                            <div class="zhuti_top_l_bottom_r row">
                                <div class="zhuti_top_l_bottom_r_l" @click="fanye(0)"><i class="el-icon-caret-left"></i>
                                </div>
                                <div class="zhuti_top_l_bottom_r_r" @click="fanye(1)"><i class="el-icon-caret-right"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="zhuti_top_r">
                        <a v-for="(item, index) in adList " :key="index" :href="item.link" target="_blank">
                            <img v-if="item.id == 2" :src="item.url" class="zhuti_top_r_img1">
                            <img v-if="item.id == 3" :src="item.url" class="zhuti_top_r_img2">
                            <img v-if="item.id == 4" :src="item.url" class="zhuti_top_r_img3">
                            <img v-if="item.id == 6" :src="item.url" class="zhuti_top_r_img4">
                        </a>
                        <!-- <a >
                            <img src="@/assets/images/1.webp" class="zhuti_top_r_img1">
                        </a>
                        <a >
                            <img src="@/assets/images/2.webp" class="zhuti_top_r_img2">
                        </a>
                        <a >
                            <img src="@/assets/images/3.webp" class="zhuti_top_r_img3">
                        </a>
                        <a >
                            <img src="@/assets/images/4.webp" class="zhuti_top_r_img4">
                        </a> -->
                    </div>
                </div>
                <!-- 主体顶部 end -->
                <!-- 精选职位 -->
                <div class="zhuti_box">
                    <div class="zhuti_box_title">精选职位</div>
                    <div class="zhuti_box_top row">
                        <div @click="clickjingxuanzhiwei(1)"
                            :class="jingxuanzhiwei == 1 ? 'zhuti_box_top_title zhuti_box_top_title_color' : 'zhuti_box_top_title'">
                            精选职位</div>
                        <div @click="clickjingxuanzhiwei(2)"
                            :class="jingxuanzhiwei == 2 ? 'zhuti_box_top_title zhuti_box_top_title_color' : 'zhuti_box_top_title'">
                            最新职位</div>
                    </div>
                    <div class="zhuti_box_main row" v-if="jingxuanzhiwei == 1">
                        <div class="zhuti_box_main_list column" v-for="( item, index ) in  jingxuanzhiweiList " :key="index"
                            @click="goToJonDetails(item)">
                            <div class="zhuti_box_main_list_main column">
                                <div class="zhuti_box_main_list_main_top row">
                                    <div class="zhuti_box_main_list_main_top_l">{{ item.name }}
                                    </div>
                                    <div class="zhuti_box_main_list_main_top_zaixian" v-if="item.onlineState == 1">
                                        <span style="font-weight: bolder;">·</span> 在线
                                    </div>
                                    <div class="zhuti_box_main_list_main_top_r" v-if="item.salaryType == 0">
                                        {{ item.salaryLowest }}-{{ item.salaryHighest }}k·{{ item.salaryCnt }}薪
                                    </div>
                                    <div class="zhuti_box_main_list_main_top_r" v-if="item.salaryType == 1">
                                        {{ item.salaryLowest }}-{{ item.salaryHighest }}k
                                    </div>
                                    <div class="zhuti_box_main_list_main_top_r" v-if="item.salaryType == 2">面议</div>
                                </div>
                                <div class="zhuti_box_main_list_main_tabs">
                                    <div class="zhuti_box_main_list_main_tabs_text">大专</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">经验不限</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">学历不限</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">五险一金</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">本科</div>
                                </div>
                            </div>
                            <div class="zhuti_box_main_list_bottom row">
                                <div class="zhuti_box_main_list_bottom_l row">
                                    <img src="@/assets/images/gongsi.png">
                                    <div :title="item.companyName">{{ item.companyName }}</div>
                                </div>
                                <div class="zhuti_box_main_list_bottom_r row">
                                    <span>企业服务</span>
                                    <span>&nbsp;|&nbsp;</span>
                                    <span>不需要融资</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="zhuti_box_main row" v-if="jingxuanzhiwei == 2">
                        <div class="zhuti_box_main_list column" v-for="( item, index ) in  jingxuanzhiweiList " :key="index"
                            @click="goToJonDetails(item)">
                            <div class="zhuti_box_main_list_main column">
                                <div class="zhuti_box_main_list_main_top row">
                                    <div class="zhuti_box_main_list_main_top_l">{{ item.name }}
                                    </div>
                                    <div class="zhuti_box_main_list_main_top_zaixian" v-if="item.onlineState == 1">
                                        <span style="font-weight: bolder;">·</span> 在线
                                    </div>
                                    <div class="zhuti_box_main_list_main_top_r" v-if="item.salaryType == 0">
                                        {{ item.salaryLowest }}-{{ item.salaryHighest }}k·{{ item.salaryCnt }}薪
                                    </div>
                                    <div class="zhuti_box_main_list_main_top_r" v-if="item.salaryType == 1">
                                        {{ item.salaryLowest }}-{{ item.salaryHighest }}k
                                    </div>
                                    <div class="zhuti_box_main_list_main_top_r" v-if="item.salaryType == 2">面议</div>
                                </div>
                                <div class="zhuti_box_main_list_main_tabs">
                                    <div class="zhuti_box_main_list_main_tabs_text">大专</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">经验不限</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">学历不限</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">五险一金</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">本科</div>
                                </div>
                            </div>
                            <div class="zhuti_box_main_list_bottom row">
                                <div class="zhuti_box_main_list_bottom_l row">
                                    <img src="@/assets/images/gongsi.png">
                                    <div :title="item.companyName">{{ item.companyName }}</div>
                                </div>
                                <div class="zhuti_box_main_list_bottom_r row">
                                    <span>企业服务</span>
                                    <span>&nbsp;|&nbsp;</span>
                                    <span>不需要融资</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="zhuti_box_bottom">
                        <div class="zhuti_box_bottom_more" @click="chakangengduo">查看更多</div>
                    </div>
                </div>
                <!-- 精选职位 end -->
                <!-- 热招职位 -->
                <!-- <div class="zhuti_box">
                    <div class="zhuti_box_title">热招职位</div>
                    <div class="zhuti_box_top row">
                        <div @click="clickrezhaozhiwe(1)"
                            :class="rezhaozhiwe == 1 ? 'zhuti_box_top_title zhuti_box_top_title_color' : 'zhuti_box_top_title'">
                            销售</div>
                        <div @click="clickrezhaozhiwe(2)"
                            :class="rezhaozhiwe == 2 ? 'zhuti_box_top_title zhuti_box_top_title_color' : 'zhuti_box_top_title'">
                            运营</div>
                    </div>
                    <div class="zhuti_box_main row" v-if="rezhaozhiwe == 1">
                        <div class="zhuti_box_main_list column" v-for="(item, index) in 9" :key="index">
                            <div class="zhuti_box_main_list_main column">
                                <div class="zhuti_box_main_list_main_top row">
                                    <div class="zhuti_box_main_list_main_top_l">{{ index }}精选职位-中外合资高级工程师中外合资高级工程师中外合资高级工程师
                                    </div>
                                    <div class="zhuti_box_main_list_main_top_r"> 8-12K·13薪</div>
                                </div>
                                <div class="zhuti_box_main_list_main_tabs">
                                    <div class="zhuti_box_main_list_main_tabs_text">大专</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">经验不限</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">学历不限</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">五险一金</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">本科</div>
                                </div>
                            </div>
                            <div class="zhuti_box_main_list_bottom row">
                                <div class="zhuti_box_main_list_bottom_l row">
                                    <img src="@/assets/images/qiyelogo.jpg">
                                    <div>公司名称公司名称公司名称公司名称公司名称公司名称</div>
                                </div>
                                <div class="zhuti_box_main_list_bottom_r row">
                                    <span>企业服务</span>
                                    <span>&nbsp;|&nbsp;</span>
                                    <span>不需要融资</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="zhuti_box_main row" v-if="rezhaozhiwe == 2">
                        <div class="zhuti_box_main_list column" v-for="(item, index) in 9" :key="index">
                            <div class="zhuti_box_main_list_main column">
                                <div class="zhuti_box_main_list_main_top row">
                                    <div class="zhuti_box_main_list_main_top_l">{{ index }}最新职位-中外合资高级工程师中外合资高级工程师中外合资高级工程师
                                    </div>
                                    <div class="zhuti_box_main_list_main_top_r"> 8-12K·13薪</div>
                                </div>
                                <div class="zhuti_box_main_list_main_tabs">
                                    <div class="zhuti_box_main_list_main_tabs_text">大专</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">经验不限</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">学历不限</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">五险一金</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">本科</div>
                                </div>
                            </div>
                            <div class="zhuti_box_main_list_bottom row">
                                <div class="zhuti_box_main_list_bottom_l row">
                                    <img src="@/assets/images/qiyelogo.jpg">
                                    <div>公司名称公司名称公司名称公司名称公司名称公司名称</div>
                                </div>
                                <div class="zhuti_box_main_list_bottom_r row">
                                    <span>企业服务</span>
                                    <span>&nbsp;|&nbsp;</span>
                                    <span>不需要融资</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="zhuti_box_bottom">
                        <div class="zhuti_box_bottom_more">查看更多</div>
                    </div>
                </div> -->
                <!-- 热招职位 end -->
                <!-- 热门企业 -->
                <!-- <div class="zhuti_box">
                    <div class="zhuti_box_title">热门企业</div>
                    <div class="zhuti_box_main row">
                        <div class="zhuti_box_main_list column" v-for="(item, index) in 9" :key="index">
                            <div class="zhuti_box_main_list_top row">
                                <img src="@/assets/images/qiyelogo2.png" class="zhuti_box_main_list_top_l">
                                <div class="zhuti_box_main_list_top_r column">
                                    <div class="zhuti_box_main_list_top_r_title">德邦快递德邦快递德邦快递德邦快递德邦快递德邦快递{{ index }}</div>
                                    <div class="zhuti_box_main_list_top_r_tabs">
                                        <span>已上市</span>
                                        <span>|</span>
                                        <span>10000人以上</span>
                                        <span>|</span>
                                        <span>快递</span>
                                    </div>
                                </div>
                            </div>
                            <div class="zhuti_box_main_list_main column" v-for="(item, index2) in 3" :key="index2">
                                <div class="zhuti_box_main_list_main_top row">
                                    <div class="zhuti_box_main_list_main_top_l">{{ index2 }}精选职位-中外合资高级工程师中外合资高级工程师中外合资高级工程师
                                    </div>
                                    <div class="zhuti_box_main_list_main_top_r"> 8-12K·13薪</div>
                                </div>
                                <div class="zhuti_box_main_list_main_tabs">
                                    <div class="zhuti_box_main_list_main_tabs_text">大专</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">经验不限</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">学历不限</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">五险一金</div>
                                    <div class="zhuti_box_main_list_main_tabs_text">本科</div>
                                </div>
                            </div>
                            <div class="zhuti_box_main_list_bottom2">
                                <div class="zhuti_box_main_list_bottom2_more">查看更多</div>
                            </div>
                        </div>
                    </div>
                    <div class="zhuti_box_bottom">
                        <div class="zhuti_box_bottom_more">查看更多</div>
                    </div>
                </div> -->
                <!-- 热门企业 end -->
                <!-- 城市热招 -->
                <!-- <div class="zhuti_box">
                    <div class="zhuti_box_title">城市热招</div>
                    <div class="zhuti_box_main row">
                        <div class="zhuti_box_main_hots row">
                            <a  v-for="(item, index) in 12" :key="index">
                                <img src="@/assets/images/city1.png" class="zhuti_box_main_hots_img">
                            </a>
                        </div>
                    </div>
                </div> -->
                <!-- 城市热招 end -->
            </div>
        </div>
        <!-- 底部 -->
        <Footer></Footer>
    </div>
</template>

<script>
import NavTop from '@/components/NavTop.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'LaIndex',
    components: { NavTop, Footer },
    data() {
        return {
            searchText: '',
            zhiweileixingState: false,
            jingxuanzhiwei: 1,
            rezhaozhiwe: 1,
            guding: false,
            params: {
                page: 1,
                pageSize: 9,
                salaryRange: '', // 月薪范围
                sortRule: 0, // 排序规则：0:最新，1:推荐
                keyword: '', // 关键词
                experience: '', // 经验
                education: '', // 学历
                customerScale: '', // 公司规模
                city: '', // 城市
                province: '', // 省份或直辖市
            },
            jingxuanzhiweiList: [],
            zuixinzhiweiList: [],
            zhiweileixingList: [],
            hangyeList: [],
            hangyeLength: 1,
            hangyeNum: 1,
            hangyegeshul: 0,
            hangyegeshur: 7,
            hotList: [],
            adList: [],
        }
    },
    created() {
        window.addEventListener('click', this.handleClickOutside, true);
    },
    mounted() {
        // document.title = '职远速聘-找高薪工作上职远速聘！招聘求职找工作！';
        // window.addEventListener('scroll', this.handleScroll);
    },
    activated() {
        // 获取广告
        this.getAdByType();
        // 获取热搜词
        this.getJobHotKwdList();
        // 职位列表
        this.getPositionList();
        // 获取职位类型
        // this.getSystemFunctions();
        // 获取所有行业
        this.getSystemIndustry();
    },
    destroyed() {
        if (process.browser) {
            window.removeEventListener('click', this.handleClickOutside, true);
        }
    },
    methods: {
        // 获取广告
        async getAdByType() {
            let res = await this.$API.getAdByTypeApi(1);
            console.log('获取广告-->', res);
            if (res.code == 0) {
                this.adList = res.data;
            }
        },
        // 获取热搜词
        async getJobHotKwdList() {
            let res = await this.$API.getJobHotKwdListApi();
            console.log('获取热搜词-->', res);
            if (res.code == 0) {
                this.hotList = res.data;
            }
        },
        handleClickOutside(event) {
            const divToHide = document.getElementById('zhiweileixingxiangqing');
            if (divToHide && !divToHide.contains(event.target)) {
                this.zhiweileixingState = false;
            }
        },
        zhiweileixing() {
            this.zhiweileixingState = true;
        },
        // 滚动后固定
        handleScroll() {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 200) {
                console.log('大于100');
                this.guding = true;
            } else {
                console.log('小于100');
                this.guding = false;
            }
        },
        // 职位搜索
        clickSearch() {
            this.$router.push('/search?keyword=' + this.searchText);
            console.log('职位搜索', this.searchText);
        },
        // 精选职位
        clickjingxuanzhiwei(val) {
            this.jingxuanzhiwei = val;

        },
        // 热招职位
        clickrezhaozhiwe(val) {
            this.rezhaozhiwe = val;
        },
        // 跳转职位详情
        goToJonDetails(item) {
            this.$router.push('/jobdetail/' + item.id);
        },
        // 职位列表
        async getPositionList() {
            let res = await this.$API.getJobListApi(this.params);
            console.log('列表-->', res);
            if (res.code == 0) {
                this.jingxuanzhiweiList = res.data.records;
                this.zuixinzhiweiList = res.data.records;
            }
        },
        // 查看更多
        chakangengduo() {
            this.$router.push('/search');
        },
        // 获取职位类型
        async getSystemFunctions() {
            let res = await this.$API.getSystemFunctionsApi();
            console.log('获取职位类型-->', res);
            this.zhiweileixingList = res.data;
        },
        // 选择职位类型
        clickzhiweileixing(item) {
            console.log('选择职位类型-->', item.id);
            // this.$router.push('/search?position=' + item.id + '&keyword=' + item.functionName);
            this.$router.push('/search?keyword=' + item.functionName);
        },
        // 获取所有行业
        async getSystemIndustry() {
            let res = await this.$API.getSystemFunctionsApi();
            console.log('获取所有行业-->', res);
            this.hangyeList = res.data;
            this.zhiweileixingList = res.data;
            this.hangyeLength = Math.ceil(res.data.length / 7);
        },
        // 翻页
        fanye(val) {
            if (val == 0) {
                this.hangyeNum -= 1;
                this.hangyegeshul -= 7;
                this.hangyegeshur -= 7;
                if (this.hangyeNum < 1) {
                    this.hangyeNum = this.hangyeLength;
                    this.hangyegeshul = 7 * (this.hangyeLength - 1);
                    this.hangyegeshur = 7 * this.hangyeLength;
                }
            }
            if (val == 1) {
                this.hangyeNum += 1;
                this.hangyegeshul += 7;
                this.hangyegeshur += 7;
                if (this.hangyeNum > this.hangyeLength) {
                    this.hangyeNum = 1;
                    this.hangyegeshul = 0;
                    this.hangyegeshur = 7;
                }
            }
        },
        // 热词跳转
        clickHot(item) {
            // console.log('热词跳转-->', item.name);
            this.$router.push('/search?keyword=' + item.name);
        }
    }

}
</script>

<style scoped>
/* 导航固定 */
.daohangguding {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 999;
}

.main_search_guding {
    position: sticky;
    top: 50px;
    left: 0;
    z-index: 999;
    background: #fff;
    width: 100%;
    padding-bottom: 20px;
    box-shadow: 0 16px 40px 0 rgba(158, 158, 158, .2);
}

.main_search_f_guding {
    display: none;
}
</style>
